import React from 'react';

import {ClientsTableHeaders} from "./ClientsTableHeaders";
import {ClientItem} from "./ClientItem";
import CustomInfiniteScroll from "../../../components/CustomInfiniteScroll";
import {useShallow} from "zustand/react/shallow";
import {useClientsStore} from "../../../stores/clientsStore";
import {useCRMStore} from "../../../stores/crmStore";

export const ClientsTable = () => {
    const { currentYear, currentMonth, search } = useCRMStore(
        useShallow((state) => ({
            currentYear: state.currentYear,
            currentMonth: state.currentMonth,
            search: state.search,
        }))
    )
    const {
        clients,
        current_page,
        has_more,
        fetchListClients,
        shouldFetchNextClients,
    } = useClientsStore(
        useShallow((state) => ({
            clients: state.clients,
            fetchListClients: state.fetchListClients,
            shouldFetchNextClients: state.shouldFetchNextClients,
            current_page: state.current_page,
            has_more: state.has_more,
            removeDeletedClientFromList: state.removeDeletedClientFromList,
            addCreatedClientToList: state.addCreatedClientToList,
        }))
    )

    const buildParams = (current_page) => {
        let queryParams = new URLSearchParams({
            month: currentMonth,
            year: currentYear
        })

        if (typeof current_page === 'number' && current_page !== 0) {
            queryParams.append("page", current_page + 1)
        }

        if (search.length) {
            queryParams.append("s", search)
        }
        return queryParams
    }

    return (
        <div
            id={"ClientsTableParentScrollRef"}
            className={'parent-scroll-ref'}
        >
            <table className={'ClientsTable'}>
                <ClientsTableHeaders/>
                <CustomInfiniteScroll
                    initialLoad={false}
                    useWindow={false}
                    pageStart={current_page}
                    loadMore={(page) => {
                        if (shouldFetchNextClients()) {
                            fetchListClients(buildParams(current_page))
                        }
                    }}
                    hasMore={has_more}
                    element={'tbody'}
                    className={'ClientTable-container'}
                    getScrollParent={() => document.getElementById("ClientsTableParentScrollRef")}
                >
                    {clients.map((client, idx) => (
                        <ClientItem key={client.id} client={client}/>
                    ))}
                </CustomInfiniteScroll>
            </table>
        </div>
    )
}